import { $api } from "../../../../../services/request.config";
import { getAvailableEmployeesDelegationAction } from "../getAvailableEmployeesDelegation.action";
import { clearAvailableEmployeesDelegationAction } from "../clearAvailableEmployeesDelegation.action";
export const getAvailableEmployeesRequestsDelegationThunkAction = () => async (dispatch) => {
    try {
        // dispatch(clearAvailableEmployeesDelegationAction());
        const response = await $api("v1/manager/delegations/eligible-delegates");

        if (response.status === 200) {
            dispatch(getAvailableEmployeesDelegationAction(response.data));
        }
    } catch (error) {
        dispatch(getAvailableEmployeesDelegationAction([]));
        // throw new Error("")
        // console.log("ERROR WHILE GETTING AVAILABLE EMPLOYEES: ", error);
    }
};
